import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d290017"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "kmt-storefinder__listitem__details" }
const _hoisted_2 = { class: "kmt-storefinder__listitem__details__inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "kmt-storefinder__listitem__buttonlist" }
const _hoisted_12 = ["href", "target", "innerHTML"]
const _hoisted_13 = ["onClick", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["kmt-storefinder__listitem", { active: _ctx.isActive }])
  }, [
    _createElementVNode("div", {
      class: "kmt-storefinder__listitem__title",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, _toDisplayString(_ctx.shorttitle), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, [
          (_ctx.store.address !== '')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.store.address), 1),
                _hoisted_3
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.store.zip !== '' || _ctx.store.city !== '')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.store.zip) + " " + _toDisplayString(_ctx.store.city), 1),
                _hoisted_4
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("dl", null, [
          (_ctx.configuration.showPhoneNumber)
            ? (_openBlock(), _createElementBlock("dt", {
                key: 0,
                innerHTML: _ctx.translationComposition.phone
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.configuration.showPhoneNumber)
            ? (_openBlock(), _createElementBlock("dd", _hoisted_6, _toDisplayString(_ctx.store.phone), 1))
            : _createCommentVNode("", true),
          _createElementVNode("dt", {
            innerHTML: _ctx.translationComposition.distance
          }, null, 8, _hoisted_7),
          _createElementVNode("dd", null, _toDisplayString(parseFloat(_ctx.store.Entfernung / 1000).toFixed(2).replace('.', ',')) + " km", 1),
          _createElementVNode("dt", {
            innerHTML: _ctx.translationComposition.opening,
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleOpenings()), ["stop","prevent"])),
            class: _normalizeClass(_ctx.isCollapsedOpenings?'collapsed':'expanded')
          }, null, 10, _hoisted_8),
          _createElementVNode("dd", {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleOpenings()), ["stop","prevent"])),
            class: _normalizeClass(_ctx.isCollapsedOpenings?'collapsed':'expanded')
          }, [
            _createElementVNode("span", { innerHTML: _ctx.openingWeekdays }, null, 8, _hoisted_9),
            _createElementVNode("div", { innerHTML: _ctx.openingHours }, null, 8, _hoisted_10)
          ], 2)
        ]),
        _createElementVNode("ul", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttonlist, (button, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              (button.type === 'link')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: button.href,
                    target: button.target,
                    class: _normalizeClass(button.cssclass),
                    innerHTML: button.text
                  }, null, 10, _hoisted_12))
                : (button.type === 'function')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      onClick: ($event: any) => (button.callback(_ctx.store)),
                      class: _normalizeClass(button.cssclass),
                      innerHTML: button.text
                    }, null, 10, _hoisted_13))
                  : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 2))
}